export enum PaymentSummaryFields {
  AlreadyPaid = 'alreadyPaid',
  IsAutoRenew = 'isAutoRenew',
}
